import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { title } from '../../constant/title';
import { moneyFormatter } from '../../helper';

const TableChart = ({ data }) => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 text-center">
          <h4>Table {title(data.metric)}</h4>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <table className="table" style={{ fontSize: 8 }}>
            <thead>
              <tr>
                <th>Merek</th>
                <th>Seri</th>
                <th>Silinder</th>
                <th>Tipe</th>
                <th>Tahun</th>
                <th>Transmisi</th>
                <th>Kota</th>
                <th>Grade</th>
                <th>Harga</th>
              </tr>
            </thead>
            <tbody>
              {data.result.map((item) => {
                let price = item.price.split('.');
                return (
                  <tr>
                    <td>{item.brand}</td>
                    <td>{item.series}</td>
                    <td>{item.cylinder}</td>
                    <td>{item.type}</td>
                    <td>{item.transmission}</td>
                    <td>{item.year}</td>
                    <td>{item.city}</td>
                    <td>{item.grade}</td>
                    <td>{moneyFormatter(price[0])}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableChart;
